/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    default-case,
    no-useless-escape
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import reactUpdate from 'immutability-helper';
import React from 'react';
import _ from 'underscore';

import notifications from 'notifications';
import Col from 'ui-library/bs/Col';
import Label from 'ui-library/bs/Label';
import Row from 'ui-library/bs/Row';
import TextArea from 'ui-library/bs/TextArea';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import * as ModalContainer from 'ui-library/ModalContainer';
import Modal from 'ui-library/modals/Modal';

interface Props {
  documentName: string;
  selectors: Array<any>;
  conflictingSelectors: Array<any>;
  deferredSelectors: any;
  onRequestClose: (...args: Array<any>) => any;
}

interface State {
  remainingConflicts: Array<any>;
  resolvedSelectors: Array<any>;
  finalSelectorOptions: Array<string>;
  previewAction: string;
}

class ResolveSelectorConflictModal extends React.Component<Props, State> {
  static open(props: any): void {
    // eslint-disable-next-line no-restricted-syntax
    props = _.extend(
      {
        onRequestClose() {
          ResolveSelectorConflictModal.close();
        },
      },
      props
    );
    ModalContainer.open(ResolveSelectorConflictModal, <ResolveSelectorConflictModal {...props} />);
  }

  static close(): void {
    ModalContainer.close(ResolveSelectorConflictModal);
  }

  static defaultProps = {
    documentName: 'This document',
  };

  constructor(props: Props) {
    super(props);
    const matchingSelector = _.findWhere(props.selectors, {
      staticId: props.conflictingSelectors[0].staticId,
    });

    this.state = {
      remainingConflicts: props.conflictingSelectors,
      resolvedSelectors: props.selectors,
      finalSelectorOptions: matchingSelector.options,
      previewAction: 'use-current',
    };
  }

  updatePreview = (e: any): void => {
    const conflictingSelector = this.state.remainingConflicts[0];
    const matchingSelector = _.findWhere(this.props.selectors, {staticId: conflictingSelector.staticId});

    const options = (() => {
      switch (e.target.value) {
        case 'use-current':
          return matchingSelector.options;
        case 'use-pasted':
          return conflictingSelector.pasteOptions;
        case 'merge':
          return _.union(conflictingSelector.pasteOptions, matchingSelector.options);
      }
    })();

    this.setState({finalSelectorOptions: options, previewAction: e.target.value});
  };

  updateFinalSelectorOptions = (e: any): void => {
    const newOptions = e.target.value.split('\n');
    this.setState({finalSelectorOptions: newOptions});
  };

  resolveSelector = (): void => {
    const conflictingSelector = this.state.remainingConflicts[0];
    const matchingSelector = _.findWhere(this.props.selectors, {staticId: conflictingSelector.staticId});
    const idx = this.props.selectors.indexOf(matchingSelector);

    // eslint-disable-next-line no-restricted-syntax
    const finalOptions = _.filter(this.state.finalSelectorOptions, (option) => Boolean(option.trim()));
    const resolvedSelector = reactUpdate(matchingSelector, {options: {$set: finalOptions}});
    const resolvedSelectors = reactUpdate(this.state.resolvedSelectors, {
      $splice: [[idx, 1, resolvedSelector]],
    });
    notifications.success(`Options for selector \"${matchingSelector.name}\" saved.`);

    const remainingConflicts = reactUpdate(this.state.remainingConflicts, {$splice: [[0, 1]]});
    if (remainingConflicts.length) {
      const nextMatchingSelector = _.findWhere(this.props.selectors, {
        staticId: remainingConflicts[0].staticId,
      });
      this.setState({
        remainingConflicts,
        finalSelectorOptions: nextMatchingSelector.options,
        previewAction: 'use-current',
        resolvedSelectors,
      });
    } else {
      this.props.onRequestClose();
      this.props.deferredSelectors.resolve(resolvedSelectors);
    }
  };

  cancel = (): void => {
    this.props.onRequestClose();
    this.props.deferredSelectors.reject();
  };

  renderComponent = (): JSX.Element => {
    const conflictingSelector = this.state.remainingConflicts[0];
    const matchingSelector = _.findWhere(this.props.selectors, {staticId: conflictingSelector.staticId});
    const rows = Math.max(
      5,
      conflictingSelector.pasteOptions.length,
      matchingSelector.options.length,
      this.state.finalSelectorOptions.length
    );

    return (
      <div>
        <p>
          {`${this.props.documentName} already has a selector named \"${conflictingSelector.name},\" but you're \
    pasting a cell with different options.`}
        </p>
        <p>You can preview merging or replacing the selector and make edits before finalizing it.</p>
        <Row>
          <Col sm={4}>
            <Label>Pasted selector</Label>
            <TextArea value={conflictingSelector.pasteOptions.join('\n')} readOnly={true} rows={rows + 4} />
          </Col>
          <Col sm={4}>
            <Label>Current selector</Label>
            <TextArea value={matchingSelector.options.join('\n')} readOnly={true} rows={rows + 4} />
          </Col>
          <Col sm={4}>
            <Label>Final selector</Label>
            <select
              className="u-tiny-spacing-bottom"
              onChange={this.updatePreview}
              value={this.state.previewAction}
            >
              <option value="use-current">Use Current</option>
              <option value="use-pasted">Use Pasted</option>
              <option value="merge">Merge</option>
            </select>
            <TextArea
              value={this.state.finalSelectorOptions.join('\n')}
              onChange={this.updateFinalSelectorOptions}
              rows={rows}
            />
            <Button
              buttonStyle={ButtonStyle.PRIMARY}
              size={ButtonSize.SMALL}
              className="u-mini-spacing-top"
              onClick={this.resolveSelector}
              text="Finalize"
            />
          </Col>
        </Row>
      </div>
    );
  };

  render(): JSX.Element {
    return (
      <Modal
        title={`Selector \"${this.state.remainingConflicts[0].name}\" Already Exists`}
        onRequestClose={this.cancel}
        buttons={[{text: 'Cancel paste', cancel: true}]}
      >
        {this.renderComponent()}
      </Modal>
    );
  }
}

export default ResolveSelectorConflictModal;
